import { render } from "./ButtonSecondary.vue?vue&type=template&id=5cfa04e2&scoped=true&ts=true"
import script from "./ButtonSecondary.vue?vue&type=script&lang=ts"
export * from "./ButtonSecondary.vue?vue&type=script&lang=ts"

import "./ButtonSecondary.vue?vue&type=style&index=0&id=5cfa04e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfa04e2"]])

export default __exports__